import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import Lottie from 'lottie-react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import { Button } from 'react-bootstrap'
import { Home, ArrowLeft } from 'iconoir-react'
import avaliacaoAnimation from '../assets/avialiacao-restaurante.json'
import avaliacaoIntroAnimation from '../assets/avialiacao-restaurante-INTRO.json'
import pedidoEnviadoAnimation from '../assets/pedido-enviado-cardapio.json'
import alguemPassouAnimation from '../assets/alguem-passou-aqui.json'
import paraquedas from '../assets/paraquedas.json'
import { getComanda } from '../services/api'
import { SendDiagonal } from 'iconoir-react'

const XERXES = 'https://xerxes.grub.digital'

const categorias = [
  { key: 'nota_comida', label: 'Comida', desc: 'Sabor, qualidade, temperatura e apresentação' },
  { key: 'nota_atendimento', label: 'Atendimento', desc: 'Simpatia, agilidade e eficiência' },
  { key: 'nota_ambiente', label: 'Ambiente', desc: 'Limpeza, conforto e clima' },
  { key: 'nota_tempo_espera', label: 'Tempo de Espera', desc: 'Rapidez no atendimento e entrega' },
  { key: 'nota_custo_beneficio', label: 'Custo-Benefício', desc: 'Preço condiz com a experiência' },
]

// Decodifica o token ofuscado para obter o comandaId
const decodeToken = (token) => {
  for (let padLen = 1; padLen < token.length - 1; padLen++) {
    for (let baseLen = 1; baseLen <= token.length - padLen - 1; baseLen++) {
      const base = token.substring(padLen, padLen + baseLen)
      const id = parseInt(base, 36)
      if (isNaN(id) || id <= 0) continue
      const expectedPad = ((id * 7 + 31) >>> 0).toString(36)
      const expectedSuffix = ((id * 13 + 97) >>> 0).toString(36)
      if (token === `${expectedPad}${base}${expectedSuffix}`) {
        return id
      }
    }
  }
  return null
}

const FeedbackPage = ({ brand: propBrand, standalone }) => {
  const { token } = useParams()
  const navigate = useNavigate()
  const brand = propBrand || window.location.host.split('.')[0]
  const comandaId = standalone ? null : decodeToken(token)

  const [notas, setNotas] = useState({ nota_comida: 0, nota_atendimento: 0, nota_ambiente: 0, nota_tempo_espera: 0, nota_custo_beneficio: 0 })
  const [nome, setNome] = useState('')
  const [telefone, setTelefone] = useState('')
  const [comentario, setComentario] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)
  const [pedido, setPedido] = useState(null)
  const [abaAtiva, setAbaAtiva] = useState('avaliacao')
  const [modalErro, setModalErro] = useState(false)

  useEffect(() => {
    if (!comandaId) return
    getComanda(brand, comandaId)
      .then(r => { if (r && r.id) setPedido(r) })
      .catch(() => { })
  }, [brand, comandaId])

  const setNota = (key, valor) => {
    setNotas(prev => ({ ...prev, [key]: valor }))
  }

  // Validação de nome: rejeita lixo, exige nome real
  const validarNome = (valor) => {
    const trimmed = valor.trim()
    // Mínimo 3 caracteres
    if (trimmed.length < 3) return 'Nome muito curto.'
    // Pelo menos 2 palavras (nome e sobrenome)
    const palavras = trimmed.split(/\s+/).filter(p => p.length > 0)
    if (palavras.length < 2) return 'Informe nome e sobrenome.'
    // Sem números
    if (/\d/.test(trimmed)) return 'Nome não pode conter números.'
    // Só letras, espaços e acentos
    if (!/^[a-zA-ZÀ-ÿ\s'-]+$/.test(trimmed)) return 'Nome contém caracteres inválidos.'
    // Detectar sequências aleatórias (4+ consoantes seguidas)
    if (/[^aeiouàáâãéêíóôõúüAEIOUÀÁÂÃÉÊÍÓÔÕÚÜ\s'-]{4,}/i.test(trimmed)) return 'Por favor, informe um nome válido.'
    // Cada palavra deve ter pelo menos 2 caracteres
    if (palavras.some(p => p.length < 2)) return 'Por favor, informe um nome válido.'
    return null
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErro('')

    if (!nome.trim() || !telefone.trim()) {
      setErro('Preencha nome e telefone.')
      return
    }
    const erroNome = validarNome(nome)
    if (erroNome) {
      setErro(erroNome)
      return
    }
    if (Object.values(notas).some(n => n === 0)) {
      setErro('Avalie todas as categorias.')
      return
    }

    setLoading(true)
    try {
      await axios.post(`${XERXES}/v1/site/${brand}/feedback`, {
        id_comanda: comandaId || null,
        nome: nome.trim(),
        telefone: telefone.trim(),
        comentario: comentario.trim() || null,
        ...notas
      })
      setEnviado(true)
    } catch (err) {
      setModalErro(true)
    }
    setLoading(false)
  }

  // Tela de link inválido (só mostra se NÃO for standalone)
  if (!comandaId && !standalone) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        textAlign: 'center'
      }}>
        <Lottie 
          animationData={paraquedas} 
          loop 
          style={{ width: 280, height: 280, marginBottom: '16px' }} 
        />
        <h1 style={{
          fontSize: '1.75rem',
          fontWeight: 700,
          color: '#1a1a1a',
          marginBottom: '12px'
        }}>
          Você não caiu aqui de paraquedas, né?
        </h1>
        <p style={{
          fontSize: '1rem',
          color: '#6b7280',
          maxWidth: '400px',
          marginBottom: '32px',
          lineHeight: 1.6
        }}>
          Este link de avaliação não é válido ou já expirou.
        </p>
        <div style={{
          display: 'flex',
          gap: '12px',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }}>
          <Button
            variant="primary"
            onClick={() => navigate('/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              borderRadius: '12px',
              fontWeight: 600,
              fontSize: '0.95rem',
              background: '#0039ff',
              border: 'none',
              boxShadow: '0 4px 12px rgba(0,57,255,0.25)'
            }}
          >
            <Home size={18} />
            Ir para o início
          </Button>
        </div>
        <div style={{
          marginTop: '48px',
          opacity: 0.7
        }}>
          <a href="https://grub.digital/" target="_blank" rel="noopener noreferrer">
            <img src="https://grubicons.s3.amazonaws.com/logo.svg" alt="Grub Digital" style={{ height: '21px' }} />
          </a>
        </div>
      </div>
    )
  }

  // Tela de sucesso
  if (enviado) {
    return (
      <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh' }}>
        <div className="container py-3">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-6">
              <div className="p-4 text-center" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginTop: '40px' }}>
                <Lottie animationData={avaliacaoAnimation} loop style={{ width: 200, height: 200, margin: '0 auto' }} />
                <h4 style={{ fontWeight: 800, color: '#1a1a1a', marginTop: '12px' }}>Obrigado pelo seu feedback!</h4>
                <p style={{ color: '#6b7280', fontSize: '0.95rem', marginBottom: '24px' }}>Sua opinião é muito importante para nós.</p>
                <Button
                  variant="primary"
                  onClick={() => navigate('/')}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '12px 24px',
                    borderRadius: '12px',
                    fontWeight: 600,
                    fontSize: '0.95rem',
                    background: '#0039ff',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,57,255,0.25)'
                  }}
                >
                  <Home size={18} />
                  Voltar ao início
                </Button>
                <div className="d-flex justify-content-center align-items-center mt-4 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                  <a href="https://grub.digital/" target="_blank" rel="noopener noreferrer">
                    <img src="https://grubicons.s3.amazonaws.com/logo.svg" alt="Grub Digital" style={{ height: '21px', verticalAlign: 'middle' }} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Tela principal do formulário
  return (
    <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh' }}>
      <div className="container py-3">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            {/* Header com Lottie */}
            <div className="text-center mb-3">
              <Lottie animationData={avaliacaoIntroAnimation} loop style={{ width: 280, height: 280, margin: '0 auto' }} />
              <h1 style={{ fontWeight: 800, fontSize: '1.5rem', color: '#1a1a1a' }}>
                {comandaId ? 'Como foi sua experiência hoje?' : 'Deixe sua avaliação'}
              </h1>
              <p style={{ color: '#6b7280', fontSize: '0.95rem', margin: '8px 0 0' }}>
                {comandaId 
                  ? <>Sua opinião faz toda a diferença. Leva menos de 1 minuto <br></br> e nos ajuda a melhorar cada detalhe da sua futura experiência.</>
                  : <>Conte como foi sua experiência conosco. Leva menos de 1 minuto <br></br> e nos ajuda a melhorar continuamente.</>
                }
              </p>
            </div>

            {/* Abas - só mostra se tem pedido */}
            {comandaId && (
            <div className="d-flex mb-3" style={{ background: '#fff', borderRadius: '10px', border: '1px solid #e5e7eb', padding: '4px' }}>
              <button
                onClick={() => setAbaAtiva('avaliacao')}
                style={{
                  flex: 1, padding: '10px', borderRadius: '8px', border: 'none', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', transition: 'all 0.2s ease',
                  background: abaAtiva === 'avaliacao' ? '#0039ff' : 'transparent',
                  color: abaAtiva === 'avaliacao' ? '#fff' : '#6b7280'
                }}
              >
                Sua avaliação
              </button>
              <button
                onClick={() => setAbaAtiva('pedido')}
                style={{
                  flex: 1, padding: '10px', borderRadius: '8px', border: 'none', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', transition: 'all 0.2s ease',
                  background: abaAtiva === 'pedido' ? '#0039ff' : 'transparent',
                  color: abaAtiva === 'pedido' ? '#fff' : '#6b7280'
                }}
              >
                Seu pedido
              </button>
            </div>
            )}

            {/* Aba: Seu Pedido */}
            {abaAtiva === 'pedido' && (
              <div className="p-4" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', animation: 'fadeInUp 0.4s ease forwards' }}>
                {pedido ? (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span style={{ fontWeight: 700, color: '#1a1a1a', fontSize: '0.9rem' }}>Pedido #{comandaId}</span>
                      {pedido.updated_at && (
                        <span style={{ color: '#9ca3af', fontSize: '0.8rem' }}>
                          {new Date(pedido.updated_at).toLocaleDateString('pt-BR')}
                        </span>
                      )}
                    </div>
                    {pedido.pedidos && pedido.pedidos.length > 0 && (
                      <div style={{ fontSize: '0.85rem', color: '#6b7280' }}>
                        {pedido.pedidos.flatMap(p => p.produtos).map((p, i) => (
                          <div key={i} style={{ padding: '6px 0', opacity: 0, animation: `fadeInUp 0.4s ease forwards`, animationDelay: `${i * 0.05}s` }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                              <img
                                src={p.imagem ? `https://grubupload.s3.amazonaws.com/${p.imagem}` : 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'}
                                alt={p.nome}
                                style={{ width: 40, height: 40, borderRadius: '8px', objectFit: 'cover', flexShrink: 0, marginTop: '2px' }}
                              />
                              <span style={{ flex: 1, textAlign: 'left', fontWeight: 600, paddingTop: '0px' }}>{p.quantidade}x {p.nome}</span>
                              <span style={{ flexShrink: 0, paddingTop: '0px' }}>R$ {(parseFloat(p.valor) * p.quantidade).toFixed(2)}</span>
                            </div>
                            {p.opcionais && p.opcionais.length > 0 && (
                              <div style={{ paddingLeft: '50px', marginTop: '2px' }}>
                                {p.opcionais.map((op, j) => (
                                  <div key={j} style={{ fontSize: '0.78rem', color: '#9ca3af', textAlign: 'left' }}>• {op.nome}</div>
                                ))}
                              </div>
                            )}
                            {p.adicionais && p.adicionais.length > 0 && (
                              <div style={{ paddingLeft: '50px', marginTop: '2px' }}>
                                {p.adicionais.map((ad, j) => (
                                  <div key={j} style={{ fontSize: '0.78rem', color: '#9ca3af', textAlign: 'left' }}>+ {ad.quantidade > 1 ? `${ad.quantidade}x ` : ''}{ad.nome}{ad.valor ? ` (R$ ${parseFloat(ad.valor).toFixed(2)})` : ''}</div>
                                ))}
                              </div>
                            )}
                            {p.complemento && (
                              <div style={{ paddingLeft: '50px', marginTop: '2px', fontSize: '0.78rem', color: '#9ca3af', fontStyle: 'italic', textAlign: 'left' }}>
                                Obs: {p.complemento}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                    {pedido.totalizadores && (
                      <div className="d-flex justify-content-between mt-2 pt-2" style={{ borderTop: '1px solid #f3f4f6', fontWeight: 700, fontSize: '0.9rem', color: '#1a1a1a' }}>
                        <span>Total</span>
                        <span style={{ color: '#10b981' }}>R$ {Number(pedido.totalizadores.valorTotal || 0).toFixed(2)}</span>
                      </div>
                    )}
                  </>
                ) : (
                  <p className="text-center" style={{ color: '#9ca3af', margin: '20px 0' }}>Carregando pedido...</p>
                )}
                <div className="d-flex justify-content-center align-items-center mt-4 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                  <a href="https://grub.digital/" target="_blank" rel="noopener noreferrer">
                    <img src="https://grubicons.s3.amazonaws.com/logo.svg" alt="Grub Digital" style={{ height: '21px', verticalAlign: 'middle' }} />
                  </a>
                </div>
              </div>
            )}

            {/* Aba: Sua Avaliação */}
            {abaAtiva === 'avaliacao' && (
              <div className="p-4" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)', animation: 'fadeInUp 0.4s ease forwards' }}>
                {erro && (
                  <div className="alert alert-danger py-2 px-3" style={{ fontSize: '0.9rem', borderRadius: '12px' }}>
                    {erro}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label small fw-bold text-muted d-block text-start">Seu nome</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nome completo"
                      value={nome}
                      onChange={e => setNome(e.target.value)}
                      required
                      style={{ borderRadius: '12px', border: '1px solid #e5e7eb', padding: '12px 16px', fontSize: '0.9rem' }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label small fw-bold text-muted d-block text-start">Seu telefone</label>
                    <PhoneInput
                      country="br"
                      onlyCountries={['br']}
                      value={telefone}
                      onChange={(value) => setTelefone(value)}
                      inputClass="phone-input-field"
                      buttonClass="phone-input-btn"
                      disableDropdown
                      masks={{ br: '(..) .....-....' }}
                      inputStyle={{ borderRadius: '12px', border: '1px solid #e5e7eb', padding: '12px 16px 12px 48px', fontSize: '0.9rem', width: '100%' }}
                      buttonStyle={{ borderRadius: '12px 0 0 12px', border: '1px solid #e5e7eb', borderRight: 'none' }}
                    />
                  </div>

                  {categorias.map(cat => (
                    <div key={cat.key} className="mb-3">
                      <label className="form-label small fw-bold text-muted d-block text-start mb-0">{cat.label}</label>
                      <small className="d-block text-start" style={{ color: '#9ca3af', marginBottom: '6px' }}>{cat.desc}</small>
                      <div className="d-flex gap-1 flex-wrap">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
                          <button
                            key={n}
                            type="button"
                            onClick={() => setNota(cat.key, n)}
                            style={{
                              width: 34,
                              height: 34,
                              borderRadius: '8px',
                              border: notas[cat.key] === n ? 'none' : '1px solid #e5e7eb',
                              background: notas[cat.key] === n
                                ? (n >= 8 ? '#10b981' : n >= 5 ? '#f59e0b' : '#ef4444')
                                : '#fff',
                              color: notas[cat.key] === n ? '#fff' : '#374151',
                              fontWeight: 600,
                              fontSize: '0.85rem',
                              cursor: 'pointer',
                              transition: 'all 0.15s ease'
                            }}
                          >
                            {n}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}

                  <div className="mb-3">
                    <label className="form-label small fw-bold text-muted d-block text-start">Comentário</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Deixe um comentário (opcional)"
                      value={comentario}
                      onChange={e => setComentario(e.target.value)}
                      style={{ borderRadius: '12px', border: '1px solid #e5e7eb', padding: '12px 16px', fontSize: '0.9rem' }}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn w-100"
                    disabled={loading || !nome.trim() || !telefone.trim() || Object.values(notas).some(n => n === 0)}
                    style={{ borderRadius: '12px', padding: '14px', fontWeight: 600, backgroundColor: (!nome.trim() || !telefone.trim() || Object.values(notas).some(n => n === 0)) ? '#c7c7c7' : '#0039ff', color: '#fff', border: 'none', transition: 'background-color 0.2s ease', fontSize: '0.95rem' }}
                  >
                    {loading ? (
                      <><span className="spinner-border spinner-border-sm me-2"></span>Enviando...</>
                    ) : (
                      <><SendDiagonal width={16} height={16} className="me-2" />Enviar Avaliação</>
                    )}
                  </button>

                  <div className="d-flex justify-content-center align-items-center mt-4 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                    <a href="https://grub.digital/" target="_blank" rel="noopener noreferrer">
                      <img src="https://grubicons.s3.amazonaws.com/logo.svg" alt="Grub Digital" style={{ height: '21px', verticalAlign: 'middle' }} />
                    </a>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* Modal de erro - feedback já registrado */}
      {modalErro && (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered" style={{ display: 'flex', alignItems: 'center', minHeight: '100vh' }}>
            <div className="modal-content" style={{ borderRadius: '16px', border: 'none' }}>
              <div className="modal-body text-center p-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <Lottie animationData={alguemPassouAnimation} loop={false} style={{ width: 195, height: 195, margin: '0 auto' }} />
                <h5 style={{ fontWeight: 700, marginBottom: '8px' }}> Ops, alguém já passou por aqui!</h5>
                <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '16px' }}>
                  Já recebemos uma avaliação para este pedido.
                  <br />
                  Se precisar falar com o restaurante, clique no botão abaixo para entrar em contato.
                </p>
                <button
                  className="btn w-100"
                  onClick={() => navigate('/')}
                  style={{ borderRadius: '12px', padding: '14px', fontWeight: 600, backgroundColor: '#0039ff', color: '#fff', border: 'none', fontSize: '0.95rem' }}
                >
                  Falar com o estabelecimento
                </button>
                <div className="d-flex justify-content-center align-items-center mt-4 pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
                  <a href="https://grub.digital/" target="_blank" rel="noopener noreferrer">
                    <img src="https://grubicons.s3.amazonaws.com/logo.svg" alt="Grub Digital" style={{ height: '21px', verticalAlign: 'middle' }} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default FeedbackPage
